import { render, staticRenderFns } from "./ProfessionsItem.vue?vue&type=template&id=2affa516&scoped=true"
import script from "./ProfessionsItem.vue?vue&type=script&lang=ts"
export * from "./ProfessionsItem.vue?vue&type=script&lang=ts"
import style0 from "./ProfessionsItem.vue?vue&type=style&index=0&id=2affa516&prod&scoped=true&lang=scss"
import style1 from "./ProfessionsItem.vue?vue&type=style&index=1&id=2affa516&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2affa516",
  null
  
)

export default component.exports